import clsx from 'clsx'
import React from 'react'
import {makeStyles} from 'external/material'
import Box from '@mui/material/Box'
import TextareaAutosize from '@mui/material/TextareaAutosize'
import {htmlToText} from '../../../../helpers/utils'

const useStyles = makeStyles(openQuestionStyles)

export default function OpenQuestion ({context,  question}) {

  const classes = useStyles()
  const {translate} = context

  const text = htmlToText(question.answer.html)

  return (
    <Box className={classes.root}>
      <TextareaAutosize
        className={classes.textarea}
        maxRows={5}
        minRows={5}
        readOnly
        value={text}
      />
    </Box>
  );
}

function openQuestionStyles (theme) {
  return {
    root: {
      flexGrow: 1,
      display: 'flex',
      paddingBottom: 20,
      flexDirection: 'column',
    },
    textarea: {
      resize: 'none',
      width: 'auto',
      padding: 8,
      flexGrow: 1,
      borderRadius: '4px',
      border: 'solid 1px #c2c7ca',
    },
  }
}
